import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';

import { ClienteInternetFormComponent } from './form';
import { ClienteInternetFormModalComponent } from './form-modal';
import { ClienteECommerceComponent } from './ecommerce';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        ClienteInternetFormComponent,
        ClienteECommerceComponent,
        ClienteInternetFormModalComponent
    ],
    exports: [
        SharedModule,

        ClienteInternetFormComponent,
        ClienteECommerceComponent,
        ClienteInternetFormModalComponent
    ]
})
export class ClienteInternetSharedModule { }
